import { render } from "./IzinNonGtk.vue?vue&type=template&id=6720f59c&scoped=true"
import script from "./IzinNonGtk.vue?vue&type=script&lang=js"
export * from "./IzinNonGtk.vue?vue&type=script&lang=js"

import "./IzinNonGtk.vue?vue&type=style&index=0&id=6720f59c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6720f59c"]])

export default __exports__